import { AlertProps } from '@mui/material';
import { FC } from 'react';
import SAlert from './Alert.styles';

const Alert: FC<AlertProps> = ({ ...props }) => {
  return <SAlert {...props} />;
};

export default Alert;
